
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 .002c-12.15 0-22 9.849-22 22C0 34.15 9.85 44 22 44s22-9.85 22-22S34.15.003 22 .003zm8.467 32.448c-.356 0-.599-.123-.931-.326-3.189-1.93-7.165-2.943-11.383-2.943-2.355 0-4.724.303-6.94.763-.36.079-.812.217-1.084.217a1.372 1.372 0 01-1.392-1.383c0-.923.532-1.385 1.197-1.511 2.717-.62 5.423-.974 8.234-.974 4.813 0 9.104 1.105 12.796 3.318.549.32.87.648.87 1.463a1.37 1.37 0 01-1.367 1.376zm2.397-5.823c-.477 0-.777-.193-1.102-.382-3.579-2.123-8.54-3.534-13.97-3.534-2.786 0-5.19.39-7.18.92-.43.119-.67.246-1.071.246a1.724 1.724 0 01-1.718-1.725c0-.935.454-1.578 1.368-1.836 2.473-.68 4.999-1.203 8.674-1.203 5.76 0 11.33 1.434 15.71 4.056.734.42 1.004.955 1.004 1.738 0 .951-.759 1.72-1.715 1.72zm2.73-6.772c-.448 0-.714-.109-1.134-.339-3.98-2.387-10.161-3.702-16.137-3.702-2.984 0-6.013.304-8.788 1.057-.32.08-.723.24-1.128.24-1.174 0-2.074-.929-2.074-2.102 0-1.196.74-1.867 1.54-2.103 3.135-.923 6.636-1.353 10.441-1.353 6.46 0 13.257 1.328 18.222 4.243.669.38 1.133.951 1.133 1.999-.001 1.198-.965 2.06-2.076 2.06z"}})])
          )
        }
      }
    